import Vue from 'vue';
import apiClient from '../../apiClient';
import { dateToLocal } from '@/modules/dates';
import config from '@/config';

const state = {
  builds: []
};

const actions = {
  ordersAssemblyGet: ({ commit }, firmId) =>
    new Promise((resolve, reject) => {
      apiClient
        .get(`/firms/${firmId}/orders/assembly`)
        .then(response => {
          const builds = response.data.orders;

          // Dates to local timezone
          builds.forEach(item => {
            const dateFields = (({
              assembly_at,
              created_at,
              completed_at
            }) => ({
              assembly_at,
              created_at,
              completed_at
            }))(item);
            for (const [key, value] of Object.entries(dateFields)) {
              item[key] = dateToLocal(
                value,
                config.dateTimeInputFormat,
                config.dateTimeInputFormat
              );
            }
          });

          // Commit to state
          commit('buildsList', builds);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    })
};

const mutations = {
  buildsList: (state, builds) => {
    Vue.set(state, 'builds', builds);
  }
};

export default {
  state,
  actions,
  mutations
};
